import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlogPostFederatedArticles, LazyBlogPostWrapper, LazyBlueskyPostEmbed } from '#components'
const lazyGlobalComponents = [
  ["BlogPostFederatedArticles", LazyBlogPostFederatedArticles],
["BlogPostWrapper", LazyBlogPostWrapper],
["BlueskyPostEmbed", LazyBlueskyPostEmbed],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
